import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'

import { RejectError } from '../../typings'

/**
 * Refresh the location of a given array of geofences
 *
 * @private
 */
export const refreshGeofenceLocations = createAsyncThunk<
  // Return type of the payload creator
  void,
  // First argument to the payload creator
  void,
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('domain/geofence/refreshLocations', async (_params, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const result = await rpc('rpc/geofence/refreshLocations', {
      category: 'rpc',
      type: 'rpc/geofence/refreshLocations',
    })

    if (result.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: result.errorMessage,
        error: result,
      })
    }
  } catch (error) {
    thunkApi.extra.journal.main(
      `Unknown error on {refreshGeofenceLocations}`,
      { tags: ['rpc', 'geofence'] },
      'error',
    )
    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: `Refresh geofence locations failed`,
      error,
    })
  }
})
